import { useEffect, useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { Check } from '@phosphor-icons/react';
import { drumLanguageAtom, drumUserProfileAtom, drumUserTokenAtom } from '../../shared/store/drumAppAtoms';
import { saveMemberProfile } from '../../shared/api/memberApi';
import { formatProfileDate, profileInitial } from '../../shared/utils/drumHelpers';
import './ProfileDetails.scss';

function ProfileDetails() {
  const language = useAtomValue(drumLanguageAtom);
  const token = useAtomValue(drumUserTokenAtom);
  const [user, setUser] = useAtom(drumUserProfileAtom);
  const [name, setName] = useState(user?.name || '');
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const joined = formatProfileDate(user?.joinedAt, language);

  useEffect(() => {
    setName(user?.name || '');
  }, [user?.name]);

  const handleSave = async () => {
    const nextName = name.trim();
    if (!nextName) {
      setSaved(false);
      setErrorMessage(language === 'ko' ? '표시 이름을 입력해 주세요.' : 'Enter a display name.');
      return;
    }
    if (!token) {
      setSaved(false);
      setErrorMessage(language === 'ko' ? '다시 로그인해 주세요.' : 'Please sign in again.');
      return;
    }

    setSaving(true);
    setErrorMessage('');
    try {
      const updated = await saveMemberProfile(token, nextName);
      setUser({ ...(user || { email: '', picture: '' }), ...updated });
      setSaved(true);
    } catch (error) {
      setSaved(false);
      setErrorMessage(error instanceof Error ? error.message : (language === 'ko' ? '변경사항을 저장하지 못했습니다.' : 'Unable to save changes.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page profile-subpage">
      <div className="page-intro"><span className="eyebrow">ACCOUNT</span><h1>Profile details</h1><p>Review the account information used across DRUM Hi.</p></div>
      <section className="profile-detail-card">
        <div className="profile-avatar large">
          {user?.picture ? <img src={user.picture} alt={user.name} /> : <span>{profileInitial(name || user?.name)}</span>}
        </div>
        <div className="profile-fields">
          <label>Display name<input value={name} onChange={(event) => { setName(event.target.value); setSaved(false); }} /></label>
          <label>Google account<input value={user?.email || ''} disabled /></label>
          <label>Joined<input value={joined} disabled /></label>
        </div>
        <button className="save-profile" type="button" onClick={handleSave} disabled={saving}>
          {saved ? <><Check weight="bold" /> Saved</> : (saving ? 'Saving...' : 'Save changes')}
        </button>
        {errorMessage ? <p className="profile-form-status">{errorMessage}</p> : null}
      </section>
    </div>
  );
}

export default ProfileDetails;
